/* global analytics */
import { v4 as uuidv4 } from 'uuid';
import CryptoJS from "crypto-js";
import { LAUNCH_DARKLY_CLIENT_SIDE_ID } from './Constants/CommonConstants';

export function setDomainUrl(host) {
  let url;
  if (host === "uat.verification.guardianlife.com") {
    url = "https://qa.guardiananytime.com";
  } else if (
    host === "www.verification.guardianlife.com" ||
    host === "verification.guardianlife.com"
  ) {
    url = "https://www.guardiananytime.com";
  } else if (host === "perf2.verification.guardianlife.com") {
    url = "https://perf2.guardiananytime.com";
  } else {
    url = "https://qa.guardiananytime.com";
  }
  return url;
}

export function getRootUrl() {
  const host = window.location.host;
  console.log("host>>>", host);
  let url = "";

  if (
    host === "www.verification.guardianlife.com" ||
    host === "verification.guardianlife.com"
  ) {
    url = "https://verification.guardianlife.com";
  } else {
    url = "https://uat.verification.guardianlife.com";
  }
  return url;
}

export function setRegion(host) {
  console.log("host in setRegion>>>", host);
  const domainUrl = setDomainUrl(host)
  let region;
  if (domainUrl === 'https://qa.guardiananytime.com') {
    region = 'UAT';
  } else if (domainUrl === 'https://www.guardiananytime.com') {
    region = 'PROD';
  } else if (domainUrl === '"https://perf2.guardiananytime.com') {
    region = 'UATPERF';
  } else {
    region = 'DEV';
  }
  return region;
}

const env = setRegion(window.location.host);

// Returns LaunchDarkly client ID based on the current host name
export const getLDClientIdByHost = () => LAUNCH_DARKLY_CLIENT_SIDE_ID[env];

export async function getApiData(url, jsonBody) {
  const corelationId = uuidv4();
  try {
    const response = await fetch(`${url}`, {
      method: "POST", // or 'PUT'
      headers: {
        "Content-Type": "text/plain",
        "x-glic-request-id": corelationId,
      },
      body: JSON.stringify(jsonBody),
    });
    return response;
  } catch (err) {
    console.log(err);
    return err;
  }
}

export const date = new Date().toLocaleString("en-US", {
  year: "numeric",
  month: "short",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  timeZoneName: "long",
});

export const checkPassword = (key, value, firstName, lastName, emailAddress, gaOktaEnabled) => {
  const atLeastOneCap = /[A-Z]+/;
  const atLeastOneLower = /[a-z]+/;
  const notAlpha = /[0-9!@?]+/;
  const atLeastOneNumber = /[0-9]+/;
  // eslint-disable-next-line no-useless-escape
  const atLeastOneNumSpecialChar = /[!@#$%^&:;,.*()_+={}\\|\[\]?~-]+/;
  const moreThanTwoReps = /(.)\1\1/;
  const illegalChar = /[<>/'"]/;
  if (key === "" || null) {
    key = emailAddress;
  }
  if(gaOktaEnabled === 'Y') {
    return (
      typeof value !== "undefined" &&
      value.length >= 8 &&
      value.length <= 50 &&
      atLeastOneCap.test(value) &&
      atLeastOneLower.test(value) &&
      atLeastOneNumber.test(value) &&
      atLeastOneNumSpecialChar.test(value) &&
      !illegalChar.test(value) &&
      value?.toLowerCase()?.indexOf(key?.toLowerCase()) === -1 &&
      value?.toLowerCase()?.indexOf(firstName?.toLowerCase()) === -1 &&
      value?.toLowerCase()?.indexOf(lastName?.toLowerCase()) === -1 &&
      value?.toLowerCase()?.indexOf(emailAddress?.toLowerCase()) === -1 &&
      !moreThanTwoReps.test(value)
    );
  } else {
    return (
      typeof value !== "undefined" &&
      value.length >= 8 &&
      value.length <= 50 &&
      atLeastOneCap.test(value) &&
      atLeastOneLower.test(value) &&
      notAlpha.test(value) &&
      !illegalChar.test(value) &&
      value?.toLowerCase()?.indexOf(key?.toLowerCase()) === -1 &&
      value?.toLowerCase()?.indexOf(firstName?.toLowerCase()) === -1 &&
      value?.toLowerCase()?.indexOf(lastName?.toLowerCase()) === -1 &&
      value?.toLowerCase()?.indexOf(emailAddress?.toLowerCase()) === -1 &&
      !moreThanTwoReps.test(value)
    );
  }
}


// to validate username
export function checkUsername(username) {
  const illegalChars = /[^a-zA-Z0-9-_@.]/;
  const atLeastOneLetter = /[A-Za-z]+/;
  return (
    username &&
    username.length >= 8 &&
    username.length <= 50 &&
    !illegalChars.test(username) &&
    atLeastOneLetter.test(username)
  );
}
// This is the secret key we use both API & React
const key = CryptoJS.enc.Base64.parse("ZGVhNm9FaFgwdEhzM0oyTw==");

export const decrypt = (inputValue) => {
  let decryptedData = CryptoJS.AES.decrypt(inputValue, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  return decryptedData.toString(CryptoJS.enc.Utf8);
}

export const encryptData = (inputValue) => {
  const encryptedData = CryptoJS.AES.encrypt(inputValue, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encryptedData.toString();
};

// Function to track user acticity based on segment analytics script
export const codeSnippetFunc = (eventName = '', page = '', methodName = 'page') => {
  analytics[methodName](eventName, {
    pageName: page,
    timeStamp : Date(),
  });
}

export const formatToPhone = (value) => {
  console.log("here")
  // if (isModifierKey(event)) return;
  
  value = value.replace(/\D/g, '');

  if(value.length > 3 && value.length <= 6) {
    value = value.slice(0,3) + '-' + value.slice(3);
  } else if(value.length > 6) {
    value = value.slice(0,3) + '-' + value.slice(3,6) + '-' + value.slice(6,10);
  }
  return value; 
};

const isNumericInput = (event) => {
  const key = event.keyCode;
  return (
    (event.shiftKey !== true && key >= 48 && key <= 57) || // Allow number line
    (event.shiftKey !== true && key >= 96 && key <= 105) // Allow number pad
  );
};

export const isModifierKey = (event) => {
  const key = event.keyCode;
  return (
    key === 35 ||
    key === 36 || // Allow Shift, Home, End
    key === 8 ||
    key === 9 ||
    key === 13 ||
    key === 46 || // Allow Backspace, Tab, Enter, Delete
    (key > 36 && key < 41) || // Allow left, up, right, down
    // Allow Ctrl/Command + A,C,V,X,Z
    ((event.ctrlKey === true || event.metaKey === true) &&
      (key === 65 || key === 67 || key === 86 || key === 88 || key === 90))
  );
};

export const enforceFormat = (event) => {
  // Input must be of a valid number format or a modifier key, and not longer than ten digits
  if (!isNumericInput(event) && !isModifierKey(event)) {
    event.preventDefault();
  }
};